import React, { useEffect } from 'react';
import { Box, Typography, Button } from '@common-ui-library/atom';
import { useI18n, useBIEvents } from '@common-ui-library/shared';
import { EleosLogo } from '@common-ui-library/molecule';
import { useSessionContext } from './SessionContext';
import { BI_UNAUTHORIZED_PAGE_VIEW } from '../Utils/biEvents';

export const UnauthorizedPage = () => {
  const { t } = useI18n();
  const { sendBIEvent } = useBIEvents();
  const { authError, session, onLogout, retryPermissionCheck } = useSessionContext();

  // Emit BI event on mount
  useEffect(() => {
    sendBIEvent(BI_UNAUTHORIZED_PAGE_VIEW, {
      unauthorized_reason: authError || 'unknown'
    });
  }, [authError, session, sendBIEvent]);

  const getTitle = () => {
    switch (authError) {
      case 'session_expired':
        return t('errors.sessionExpired');
      case 'server_error':
        return t('errors.somethingWentWrong');
      case 'no_site':
      case 'no_permission':
      default:
        return t('errors.unauthorized');
    }
  };

  const getMessage = () => {
    switch (authError) {
      case 'session_expired':
        return t('errors.sessionExpiredMessage');
      case 'server_error':
        return t('errors.serverErrorMessage');
      case 'no_site':
      case 'no_permission':
      default:
        return t('errors.unauthorizedMessage');
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        bgcolor: 'background.default',
        p: 3,
        textAlign: 'center',
      }}
    >
      <Box sx={{ mb: 4 }}>
        <EleosLogo />
      </Box>
      <Typography variant="h4" gutterBottom>
        {getTitle()}
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ mb: 4, maxWidth: 400 }}>
        {getMessage()}
      </Typography>
      <Box sx={{ display: 'flex', gap: 2 }}>
        {authError === 'server_error' && (
          <Button variant="contained" color="primary" onClick={retryPermissionCheck}>
            {t('actions.retry')}
          </Button>
        )}
        <Button 
          variant={authError === 'server_error' ? 'outlined' : 'contained'} 
          color="primary" 
          onClick={onLogout}
        >
          {authError === 'session_expired' 
            ? t('actions.loginAgain')
            : t('actions.logout')
          }
        </Button>
      </Box>
    </Box>
  );
};

